<template>
  <ul class="c-games_gameListHeader_sort">
    <li
      class="c-games_gameListHeader_order"
      v-for="(orderType, index) in orderTypes"
      :key="`orderType_${index}`"
    >
      <label class="c-games_gameListHeader_orderLabel">
        <input
          class="c-games_gameListHeader_inputElement"
          type="radio"
          name="orderType"
          :checked="orderType === currentOrderType"
          :value="orderType"
          @change="onChange"
        >
        <span class="c-games_gameListHeader_labelElement">{{ orderType }}</span>
        <i class="c-games_gameListHeader_indicatorElement"></i>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    orderTypes: Array,
    currentOrderType: String
  },
  methods: {
    onChange (e) {
      const orderType = e.target.value
      this.$emit('selectOrderType', orderType)
    }
  }
}
</script>

<style lang="scss">
// styled by external css
</style>
